import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import DashboardContent from "../atoms/DashboardContent";
import { useParams } from "react-router-dom";
import { Redirect } from "react-router-dom";
import { handleChange, handleSubmit } from "../../atoms/Upsert";
import Input from "../../atoms/Input";
import Select from "../../atoms/Select";
import ButtonCancel from "../../atoms/ButtonCancel";
import ButtonSave from "../../atoms/ButtonSave";
import { getStatuses } from "../../../store/slice/statusSlice";
import {
    getFileType,
    insertFileType,
    updateFileType,
} from "../../../store/slice/fileTypeSlice";
import routes from "../constants/routes";

export default function (props) {
    const dispatch = useDispatch();
    const [values, setValues] = useState({});
    const [redirect, setRedirect] = useState(false);
    const statuses = useSelector((state) => state.status.rows);
    const { id } = useParams();

    React.useEffect(() => {
        dispatch(getStatuses({ type: "Default" }));
        if (id) {
            dispatch(getFileType({ id: id })).then((response) => {
                setValues(response.payload);
            });
        }
    }, []);

    function Content(props) {
        return (
            <div className="card card-primary">
                <form
                    type="post"
                    onSubmit={(event) => {
                        handleSubmit(event, {
                            id: id,
                            values: values,
                            functions: {
                                insert: insertFileType,
                                update: updateFileType,
                            },
                            callback: {
                                function: setRedirect,
                                params: `${routes.index}${routes.fileType.root}`,
                            },
                            dispatch: dispatch,
                        });
                    }}
                >
                    <div className="card-body row">
                        <div className="col-sm-6 col-md-4">
                            <Input
                                label="Name"
                                name="name"
                                value={values.name}
                                handleChange={(event) => {
                                    handleChange(event, values, setValues);
                                }}
                            />
                        </div>
                        <div className="col-sm-12 col-md-4">
                            <Select
                                label="Status"
                                name="status_id"
                                options={statuses}
                                value={values.status_id}
                                handleChange={(event) => {
                                    handleChange(event, values, setValues);
                                }}
                            />
                        </div>
                    </div>
                    <div className="card-footer text-right">
                        <ButtonCancel /> <ButtonSave />
                    </div>
                </form>
            </div>
        );
    }

    return (
        <div>
            {redirect && <Navigate to={redirect} />}
            <DashboardContent
                title={id ? "Edit File Types" : "Create File Types"}
                icon="fa fa-list-alt"
                content={Content(props)}
                breadcrumb={[
                    {
                        label: "File Types",
                        to: `${routes.index}${routes.fileType.root}`,
                    },
                    { label: id ? "Edit" : "New" },
                ]}
            />
        </div>
    );
}
